import "./contact-form.scss";
import React, { useState } from "react";
import axios from "axios";
import { Link, navigate } from "gatsby";
import useTranslation from "locales";

const ContactForm = ({ lang }) => {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [legal, setLegal] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const { t } = useTranslation(lang);

  const resetForm = () => {
    setIsSending(false);
    setEmail("");
    setPhone("");
    setMessage("");
    setFirstName("");
  };

  const formSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);

    const formData = new FormData();

    formData.set("firstName", firstName);
    formData.set("email", email);
    formData.set("phone", phone);
    formData.set("message", message);

    axios({
      method: "post",
      url: "https://brand.ogrodswiatel.pl/wp-json/contact-form-7/v1/contact-forms/5/feedback/",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((res) => {
        resetForm();
        navigate("/podziekowanie");
      })
      .catch((error) => {
        console.log("Submit error");
        console.log(error);
      });
  };
  return (
    <div className="contact-form">
      <form onSubmit={formSubmit} className="contact-form__form">
        <div className="contact-form__input-group">
          <input
            type="text"
            className="contact-form__input"
            placeholder={t("Imię i nazwisko*")}
            required
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div className="contact-form__input-group">
          <input
            type="email"
            className="contact-form__input"
            placeholder={t("Adres email*")}
            required
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="contact-form__input-group">
          <input
            type="tel"
            className="contact-form__input"
            placeholder={t("Numer telefonu")}
            value={phone}
            id="phone"
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
        <div className="contact-form__input-group">
          <textarea
            className="contact-form__textarea"
            placeholder={t("Wiadomość")}
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
        <div className="contact-form__small-info">*{t("pola obowiązkowe")}</div>
        <div className="contact-form__input-gropup">
          <label className="checkbox-wrapper" htmlFor="acceptance1">
            <input
              type="checkbox"
              name="acceptance1"
              id="acceptance1"
              onChange={(e) => setLegal(!legal)}
            />
            <span>
              *{t("Zapoznałem się i akceptuję")}{" "}
              <Link
                to={t("/polityka-prywatnosci/")}
                className="contact-form__yellow-hover"
              >
                {t("politykę prywatności")}
              </Link>
            </span>
          </label>
        </div>
        <button
          type="submit"
          className="contact-form__btn btn btn--white"
          disabled={!legal && "disabled"}
        >
          {isSending ? t("Wysyłanie...") : t("Wyślij")}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
